import { createLead } from 'services/studentService';

import { getSalesExecutiveCode } from 'utils/auth/authHelper';
import { getDifferenceInDays } from 'utils/date';

export const saveLead = (student, lead) => createLead({ student, lead });

export const getAgeRanges = () => {
  const items = [
    {
      value: '15',
      text: 'até 15 anos',
    },
    {
      value: '16-17',
      text: '16 - 17 anos',
    },
    {
      value: '18-24',
      text: '18 - 24 anos',
    },
    {
      value: '25-35',
      text: '25 - 35 anos',
    },
    {
      value: '36-45',
      text: '36 - 45 anos',
    },
    {
      value: '46-59',
      text: '46 - 59 anos',
    },
    {
      value: '+60',
      text: '60 anos ou mais',
    },
  ];

  return items;
};

export const getPersonas = () => {
  const items = [
    {
      value: 'persona_1',
      text: 'Jovem em busca de experiência e aprendizado',
    },
    {
      value: 'persona_2',
      text: 'Profissional buscando qualificação',
    },
    {
      value: 'persona_3',
      text: 'Sou mais experiente e quero curtir a vida',
    },
  ];

  return items;
};

export const getStages = () => {
  const items = [
    {
      value: 'initial_research',
      text: 'Iniciando as pesquisas (ainda não sei de nada)',
    },
    {
      value: 'few_researchs',
      text: 'Já pesquisei um pouco (tenho algumas dúvidas)',
    },
    {
      value: 'lots_researches',
      text: 'Já pesquisei bastante (já sei mais ou menos o que quero)',
    },
    {
      value: 'ready_to_close',
      text: 'Já me decidi',
    },
    {
      value: 'not_priority',
      text: 'Não quero fazer intercâmbio no momento',
    },
  ];

  return items;
};

export const getPaymentPlans = () => {
  const items = [
    {
      value: 'a_vista_boleto',
      text: 'À vista com desconto no boleto',
    },
    {
      value: 'parcelamento_cartao_credito',
      text: 'Parcelamento no cartão de crédito',
    },
    {
      value: 'parcelamento_boletos_agendados',
      text: 'Parcelamento em boletos bancários agendados',
    },
    {
      value: 'cartao_boleto',
      text: 'Parte via cartão de crédito, parte via boletos agendados',
    },
    {
      value: 'deposit_boleto',
      text: 'Entrada via boleto e o restante até 35 dias antes do embarque',
    },
    {
      value: 'deposit_cartao',
      text: 'Entrada via cartão de crédito e o restante até 35 dias antes do embarque',
    },
    {
      value: 'nao_sabe',
      text: 'Ainda não tenho certeza',
    },
  ];

  return items;
};

export const getInvestiments = () => {
  const items = [
    {
      value: '1',
      text: 'R$ 2.000,00 - R$ 5.000,00',
    },
    {
      value: '2',
      text: 'R$ 5.000,00 - R$ 10.000,00',
    },
    {
      value: '3',
      text: 'R$ 10.000,00 - R$ 20.000,00',
    },
    {
      value: '4',
      text: 'R$ 20.000,00 - R$ 35.000,00',
    },
    {
      value: '5',
      text: 'R$ 35.000 - R$ 60.000,00',
    },
    {
      value: '6',
      text: '+R$ 60.000,00',
    },
  ];

  return items;
};

export const getRanges = () => {
  const items = [
    {
      value: 'ready_to_close',
      text: 'Estou pronto para fechar',
    },
    {
      value: 'close_next_week',
      text: 'Quero fechar na semana que vem',
    },
    {
      value: 'close_next_month',
      text: 'Quero fechar no mês que vem',
    },
    {
      value: 'next_3_to_6_months',
      text: 'Quero fechar entre 3 a 6 meses',
    },
    {
      value: 'next_7_to_12_months',
      text: 'Quero fechar entre 7 a 12 meses',
    },
    {
      value: 'not_interested',
      text: 'Não tenho interesse em fechar por enquanto',
    },
  ];

  return items;
};

export const leadObjective = [
  {
    value: 'personal_fulfillment',
    text: 'Aprendizado e realização pessoal',
  },
  {
    value: 'professional',
    text: 'Crescimento profissional',
  },
  {
    value: 'entertainment',
    text: 'Entretenimento e cultura',
  },
  {
    value: 'live_and_work_abroad',
    text: 'Estudar e/ou morar no exterior',
  },
  {
    value: 'travel_tourism',
    text: 'Viagens e turismo',
  },
  {
    value: 'other',
    text: 'Outros',
  },
];

export const leadInvestiment = [
  {
    value: '1',
    text: 'Menos de R$ 50,00',
  },
  {
    value: '2',
    text: 'R$ 51,00 a R$ 100,00',
  },
  {
    value: '3',
    text: 'R$ 101,00 a R$ 200,00',
  },
  {
    value: '4',
    text: 'R$ 201,00 a R$ 300,00',
  },
  {
    value: '5',
    text: 'R$ 301,00 a R$ 400,00',
  },
  {
    value: '6',
    text: 'Mais de R$ 400,00',
  },
];

export const leadStartDate = [
  {
    value: '4',
    text: 'Imediatamente',
  },
  {
    value: '3',
    text: 'Na próxima semana',
  },
  {
    value: '2',
    text: 'No próximo mês',
  },
  {
    value: '1',
    text: 'Não tenho certeza ainda',
  },
];

export const leadAbroadWill = [
  {
    value: '1',
    text: 'Nunca pensei sobre isso',
  },
  {
    value: '2',
    text: 'Tenho vontade',
  },
  {
    value: '3',
    text: 'Já fiz e faria novamente',
  },
  {
    value: '4',
    text: 'Já fiz e não faria novamente',
  },
];

export const shouldUnlockPrice = (lead, user) =>
  getSalesExecutiveCode(user) ? true : isPriceOpen(lead);

const isPriceOpen = (lead) => Object.keys(lead).length > 0 && !!lead?.priceOpen;

export const setPriceOpen = (lead, open = true) => {
  lead.priceOpen = open;
};

export const setQualifiedLead = (lead, qualified) => {
  lead.qualifiedLead = qualified;
};

export const mountLeadUtm = (obectToAdd, query) => {
  obectToAdd.siteSourceName = query?.site_source_name;
  obectToAdd.term = query?.utm_term;
  obectToAdd.campaign = query?.utm_campaign;
  obectToAdd.content = query?.utm_content;
  obectToAdd.device = query?.utm_device;
  obectToAdd.source = query?.utm_source;
  obectToAdd.medium = query?.utm_medium;
  obectToAdd.affiliateId = query?.affiliate;
};

const findCountryByLead = (lead, countries) =>
  countries.find((country) => country.id === lead.country_id);

const findCityByLeadAndCountry = (lead, country) => {
  if (!country) return null;
  return country.cities.find((city) => city.id === lead.city_id);
};

export const buildSchoolUrlWithLeadInfo = (lead, countries) => {
  const schoolsRoute = '/schools';

  if (!lead) return schoolsRoute;

  const country = findCountryByLead(lead, countries);

  if (!country) return schoolsRoute;

  const city = findCityByLeadAndCountry(lead, country);

  if (!city) return `${schoolsRoute}/${country.slugName}`;

  return `${schoolsRoute}/${country.slugName}/${city.slugName}`;
};

export const showScheduledButton = (lead) => {
  if (!lead?.hasMeetingScheduled) return false;
  if (!lead?.meetingScheduledDate) return true;

  const today = new Date();
  const meetingDate = new Date(lead?.meetingScheduledDate);
  const timeDiffInDays = getDifferenceInDays(today, meetingDate);

  if (timeDiffInDays < 5) return true;

  return false;
};
